'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require('./PagingModel');

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

var _Customer = require('./Customer');

var _Customer2 = _interopRequireDefault(_Customer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerModel = function (_PagingModel) {
    _inherits(CustomerModel, _PagingModel);

    function CustomerModel(observers, id, request) {
        _classCallCheck(this, CustomerModel);

        var _this = _possibleConstructorReturn(this, (CustomerModel.__proto__ || Object.getPrototypeOf(CustomerModel)).call(this, observers, id, request));

        _this.Customer = new _Customer2.default();

        _this.CustomersAbove = [];

        _this.Customers = [];
        _this.Success = false;

        _this.Schools = [];

        _this.DeleteCustomerRelationSuccess = false;
        return _this;
    }

    _createClass(CustomerModel, [{
        key: 'setCustomer',
        value: function setCustomer(Customer) {
            var me = this;
            if (Customer !== null && Customer !== undefined) {
                var result = Customer;
                var sal = '';
                if (result.Gender) {
                    switch (localStorage.getItem("vas_language")) {
                        case 'de':
                            if (result.Gender === "weiblich") {
                                sal = "Frau";
                            } else if (result.Gender === "männlich") {
                                sal = "Herr";
                            } else if (result.Gender === "divers") {
                                sal = "";
                            }
                            break;
                        case 'en':
                            if (result.Gender === "weiblich") {
                                sal = "Mrs";
                            } else if (result.Gender === "männlich") {
                                sal = "Mr";
                            } else if (result.Gender === "divers") {
                                sal = "";
                            }
                            break;
                        default:
                            break;
                    }
                }
                me.Customer.Id = result.Id;
                me.Customer.ClientId = result.ClientId;
                me.Customer.Salutation = sal;
                me.Customer.Name1 = result.Name1;
                me.Customer.Name2 = result.Name2;
                me.Customer.Name3 = result.Name3;
                //me.Customer.DateOfBirth = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(result.DateOfBirth,true));
                me.Customer.DateOfBirth = result.DateOfBirth;
                me.Customer.Street = result.Street;
                me.Customer.HouseNumber = result.HouseNumber;
                me.Customer.HouseNumberAddition = result.HouseNumberAddition;
                me.Customer.PostCode = result.PostCode;
                me.Customer.City = result.City;
                me.Customer.CustomerNumber = result.CustomerNumber;
                me.Customer.Email = result.Email;
                me.Customer.Phone = result.Phone;
                me.Customer.Phone2 = result.Phone2;
                me.Customer.Fax = result.Fax;
                me.Customer.Gender = result.Gender;
                me.Customer.Class = result.Class;
                me.Customer.GradeLevel = result.GradeLevel;
                me.Customer.Country = result.Country;
                me.Customer.Title = result.Title;
                me.Customer.RegNr = result.RegNr;
                me.Customer.MarketingPost = result.MarketingPost;
                me.Customer.MarketingEmail = result.MarketingEmail;
                me.Customer.MarketingPhone = result.MarketingPhone;
                me.Customer.FlagMarketing = result.FlagMarketing;
                me.Customer.NoMail = result.NoMail;
                me.Customer.CustomerCategory = result.CustomerCategory;
                me.Customer.Zusatz2 = result.Zusatz2;
            }
        }
    }, {
        key: 'GetCustomerById',
        value: function GetCustomerById(id) {
            var me = this;
            this.request.setRequest("/customers/" + id);
            this.request.setType("GET");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.setCustomer(data.Data[0]);
                    }
                }
                var id = me.Id ? me.Id : "Customer";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'UpdateCustomer',
        value: function UpdateCustomer() {
            var me = this;
            this.request.setRequest("/Customers");
            this.request.setData(JSON.stringify(this.Customer));
            this.request.setType("PUT");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.setCustomer(data.Data[0]);
                    }
                }
                var id = me.Id ? me.Id : "CustomerPUT";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetCustomersAboveByCustomerId',
        value: function GetCustomersAboveByCustomerId(customerId, validFrom, flagFkv, customerAboveId) {
            var me = this;
            if (customerId != null && customerId != undefined) {

                var req = "/Customers/" + customerId + "/CustomerAbove" + this.setSendData(null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, validFrom, flagFkv, customerAboveId);
                this.request.setRequest(req);
                this.request.setType("GET");
                this.request.setCallback(function (data) {
                    if (data) {
                        if (data.Data) {
                            me.CustomersAbove = data.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "CustomersAbove";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: 'GetCustomers',
        value: function GetCustomers(senddata, start, limit, orderColumn, orderDirection, customerCategory, firstName, lastName, street, postcode, city, customerNumber, email, regNr, customerAboveId) {
            var me = this;
            var reqString = "/Customers" + this.setSendData(senddata, start, limit, orderColumn, orderDirection, null, null, null, null, null, null, null, null, customerCategory, firstName, lastName, street, postcode, city, customerNumber, email, regNr, null, null, null, customerAboveId);
            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    //let notVisible = 0;
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            me.Customers = result.Data.Data;
                            /*let res = result.Data.Data;
                            let customers = [];
                            for(let i = 0; i< res.length; i++){
                                if(res[i].Name1 !== null && res[i].Name1 !== undefined ){
                                    if(res[i].Name1 !== '*** gelöscht ***'){
                                        customers.push(res[i]);              
                                    }else{  
                                        notVisible++;
                                    }
                                }
                            }
                            me.Customers = customers;*/
                        }
                    }
                    /*if(result.Data.Count !== null && result.Data.Count !== undefined){
                        result.Data.Count -= notVisible;
                    }*/
                    me.setResult(result);
                }
                var id = me.Id ? me.Id : "Customers";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetCustomersWithCustomerAbove',
        value: function GetCustomersWithCustomerAbove(senddata, start, limit, orderColumn, orderDirection, customerCategory, firstName, lastName, street, postcode, city, customerNumber, email, regNr, customerAboveId) {
            var me = this;
            var reqString = "/Customers/CustomerWithCustomerAbove" + this.setSendData(senddata, start, limit, orderColumn, orderDirection, null, null, null, null, null, null, null, null, customerCategory, firstName, lastName, street, postcode, city, customerNumber, email, regNr, null, null, null, customerAboveId);
            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    //let notVisible = 0;
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            me.Customers = result.Data.Data;
                            /*let res = result.Data.Data;
                            let customers = [];
                            for(let i = 0; i< res.length; i++){
                                if(res[i].Name1 !== null && res[i].Name1 !== undefined ){
                                    if(res[i].Name1 !== '*** gelöscht ***'){
                                        customers.push(res[i]);              
                                    }else{  
                                        notVisible++;
                                    }
                                }
                            }
                            me.Customers = customers;*/
                        }
                    }
                    /*if(result.Data.Count !== null && result.Data.Count !== undefined){
                        result.Data.Count -= notVisible;
                    }*/
                    me.setResult(result);
                }
                var id = me.Id ? me.Id : "CustomersWithCustomersAbove";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'SetCustomerWithSchool',
        value: function SetCustomerWithSchool(schoolId) {
            var sendData = {};
            sendData.Customer = this.Customer;
            sendData.SchoolId = schoolId;

            var me = this;

            this.request.setRequest("/CustomersWithSchool");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                me.Success = true;
                var id = me.Id ? me.Id : "CustomersWithSchool";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'GetSchoolsOfCustomer',
        value: function GetSchoolsOfCustomer(senddata, start, limit, orderColumn, orderDirection) {
            var me = this;
            var reqString = "/Customers/Schools" + this.setSendData(senddata, start, limit, orderColumn, orderDirection);
            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            me.Schools = result.Data.Data;
                        }
                    }
                }
                var id = me.Id ? me.Id : "SchoolsCustomer";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'InsertCustomer',
        value: function InsertCustomer() {
            var me = this;
            this.request.setRequest("/Customers");
            this.request.setData(JSON.stringify(this.Customer));
            this.request.setType("POST");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.setCustomer(data.Data[0]);
                    }
                }
                var id = me.Id ? me.Id : "InsertCustomer";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'InsertCustomerWithCustomerAbove',
        value: function InsertCustomerWithCustomerAbove(id) {
            var me = this;
            this.request.setRequest("/Customers/" + id);
            this.request.setData(JSON.stringify(this.Customer));
            this.request.setType("POST");
            this.request.setCallback(function (data) {
                if (data) {
                    if (data.Data) {
                        me.setCustomer(data.Data[0]);
                    }
                }
                var id = me.Id ? me.Id : "InsertCustomer";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'DeleteCustomerRelation',
        value: function DeleteCustomerRelation(customerid, customerAboveId, validTo) {
            var me = this;
            if (customerid && customerAboveId && validTo) {
                var req = "/customerAbove/" + customerAboveId + "/customers/" + customerid;
                //this.request.setData(JSON.stringify({endDate : validTo}));
                if (validTo) {
                    req += "?endDate=" + validTo;
                }
                this.request.setRequest(req);
                this.request.setType("DELETE");
                this.request.setCallback(function (data) {
                    if (data) {
                        if (data.Data) {
                            me.DeleteCustomerRelationSuccess = data.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "DeleteCustomerRelation";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }]);

    return CustomerModel;
}(_PagingModel3.default);

exports.default = CustomerModel;